module.exports = __webpack_public_path__ + "assets/img/thumb_ch3-item-1.1c6d499e.jpg";